export default __webpack_public_path__ + "static/media/IMG_2180cropped.6bcda2e7.jpeg";